import { useMutation } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

export const useBookingCharterOpsMutation = (bookingId: string, onDone: (data: any) => void) => {
  const { toast } = useToast();
  return useMutation({
    mutationFn: (body: { checklist?: Record<string, boolean>; markReceived?: Record<string, boolean>; crewNotes?: string | null }) =>
      fetch<{ data: any }>(`/api/bookings/${bookingId}/charter-ops`, "PATCH", body),
    onSuccess: (res: any) => onDone(res.data),
    onError: (error: any) => toast({ title: "Couldn't save", description: error?.message, variant: "destructive" }),
  });
};
